import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { caseStudies } from '@/data/caseStudies';

export const CaseStudiesTeaser = () => (
  <section className="section" id="case-studies">
    <div className="container mx-auto max-w-6xl px-4">
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-4"
      >
        Case Studies
      </motion.h2>
      <p className="text-muted-foreground text-center text-lg mb-14 max-w-2xl mx-auto">
        Real brands. Real shoots. Real results.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {caseStudies.slice(0, 3).map((c, i) => (
          <motion.div
            key={c.slug}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: (i % 3) * 0.08 }}
          >
            <Link
              to={`/case-studies/${c.slug}`}
              className="glass-card group h-full flex flex-col !p-0 overflow-hidden hover:border-primary/40 transition-all"
            >
              <div className="aspect-[4/3] w-full overflow-hidden bg-primary/10">
                <img
                  src={c.image}
                  alt={`${c.brand} — ${c.industry}`}
                  loading="lazy"
                  style={{ objectPosition: c.imagePosition ?? 'center' }}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-start justify-between gap-3 mb-3">
                  <h3 className="text-xl md:text-2xl font-bold">{c.brand}</h3>
                  <span className="shrink-0 inline-flex items-center rounded-full bg-primary/10 border border-primary/20 px-3 py-1 text-xs font-semibold text-primary">
                    {c.industry}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground mb-5">{c.tagline}</p>
                <span className="mt-auto inline-flex items-center gap-2 self-start rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-semibold">
                  Read the study case
                  <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <p className="text-muted-foreground mb-5">
          And many more brands we've filmed for.
        </p>
        <Link
          to="/case-studies"
          className="btn-hero-accent inline-flex items-center justify-center gap-2 px-8"
        >
          View all case studies
          <ArrowUpRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  </section>
);
